import React from 'react';

const Product = ({ product, onToggleFavorite, onAddToCart, renderStars }) => {
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
      {/* Image du produit */}
      <div className="relative">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-56 object-cover"
          onError={(e) => {
            e.target.src = "https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?q=80&w=765&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";
          }}
        />
        {/* Bouton favori */}
        <button
          onClick={() => onToggleFavorite(product.id)}
          className="absolute top-2 right-2 p-2 bg-white rounded-full shadow-md hover:bg-gray-50 transition-colors"
        >
          <svg
            className={`w-5 h-5 ${product.isFavorite ? 'text-red-500 fill-current' : 'text-gray-400'}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
          </svg>
        </button>
      </div>

      {/* Contenu de la carte */}
      <div className="p-4">
        {/* Catégorie */}
        <span className="text-sm text-gray-500 bg-gray-100 px-2 py-1 rounded-full">
          {product.category}
        </span>

        {/* Nom du produit */}
        <h3 className="text-lg font-semibold text-gray-900 mt-2 mb-2 line-clamp-2">
          {product.name}
        </h3>

        {/* Prix */}
        <div className="mb-3">
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-500 line-through">
              {product.originalPrice.toLocaleString()} Fcfa
            </span>
            <span className="text-sm font-semibold text-red-800">
              -{product.discount}%
            </span>
          </div>
          <div className="text-xl font-bold text-red-500">
            {product.currentPrice.toLocaleString()} Fcfa
          </div>
        </div>

        {/* Note et avis */}
        <div className="flex items-center gap-2 mb-3">
          <div className="flex">
            {renderStars(product.rating)}
          </div>
          <span className="text-sm text-gray-600">
            ({product.reviews} avis clients)
          </span>
        </div>

        {/* Vendeur */}
        <p className="text-sm text-gray-700 mb-4 underline">
          {product.seller}
        </p>

        {/* Bouton Ajouter au panier */}
        <button
          onClick={() => onAddToCart(product.id)}
          className="w-full py-2 px-4 rounded-full transition-colors flex items-center justify-center gap-2 bg-white text-black border border-gray-800 hover:border-0 hover:bg-gray-50 hover:bg-orange-hover hover:text-white"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="21.283" height="21.283" viewBox="0 0 21.283 21.283" className="transition-colors">
            <g transform="translate(0.75 0.75)">
              <path d="M1148.968,58.484A1.484,1.484,0,1,1,1147.484,57,1.483,1.483,0,0,1,1148.968,58.484Z" transform="translate(-1140.064 -40.184)" fill="none" stroke="currentColor" stroke-width="1.5" />
              <path d="M1157.968,58.484A1.484,1.484,0,1,1,1156.484,57,1.483,1.483,0,0,1,1157.968,58.484Z" transform="translate(-1140.162 -40.184)" fill="none" stroke="currentColor" stroke-width="1.5" />
              <path d="M1143.957,41.978h11.87a3.956,3.956,0,0,1,3.957,3.957v4.946a3.956,3.956,0,0,1-3.957,3.957h-7.913a3.956,3.956,0,0,1-3.956-3.957Zm0,0A1.981,1.981,0,0,0,1141.978,40H1140m3.957,5.935h15.332" transform="translate(-1140 -40)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
            </g>
          </svg>
          Ajouter en ligne
        </button>
      </div>
    </div>
  );
};

export default Product; 